module.exports = __webpack_public_path__ + "static/media/code-tag.fb6a4c89.svg";